import bosApproval from '../../assets/common/bos-approval.svg';
import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const registrationApproval: AppContent['registrationApproval'] = {
  registrationApprovalContent: [
    {
      serviceName: 'Business Internet Banking',
      header: 'Does anyone else need to approve your registration?',
      content:
        'If your bank mandate has ‘one to sign’ signing instructions you won’t need anyone else to approve your registration.',
      imageAltText: 'Lloyds banking People Illustration',
      imageSrc: bosApproval,
      faqHeader: 'Need some help?',
      yesBtn: 'Yes, I need approval',
      yesBtnHref: '/three-steps-to-register-approval',
      noBtn: 'No, I don’t need approval',
      noBtnHref: '/switch-to-mobile',
      noBtnHrefForMobile: '/about-the-business',
      previousLink: 'Previous',
      previousHref: '/full-signatory',
    },
  ],
};

export default registrationApproval;
